import*as r from"react";import{useLatestValue as n}from'./use-latest-value.js';let c=function(t){let e=n(t);return r.useCallback((...a)=>e.current(...a),[e])};export{c as useEvent};
